<template>
  <div >
    <ul v-if="messages && messages.length>0" class="w-11/12 md:w-3/4 mx-auto">
      <li v-for="recipient in recipients" :key="recipient">
        <ul class="mt-10 border-double border-4
          border-beige-academy-300" >
          <li v-for="message in messagesToUser(recipient)" :key="message.id"
            class="p-4 text-sm border-b border-beige-academy-300 flex flex-col
               text-left bg-white" >
            <div class="flex font-bold text-lg text-black">
              <div class="pr-4">
                 to: {{ message.to_user.name.toUpperCase() }}
              </div>
              <div >
                [ {{ message.subject }} ]
              </div>

            </div>
            <div class="text-md text-black">
              {{ message.body }}
            </div>
            <div class="flex justify-end text-md pt-4">
              <button class="p-2 uppercase mr-4 border border-beige-academy-300 px-4
              text-white bg-beige-academy-300 hover:bg-white hover:text-beige-academy-300"
                 @click="answer(message)">
                  {{ $t('messages.answer') }}
              </button>
              <button class="p-2 uppercase border border-beige-academy-300 px-4
              text-white bg-beige-academy-300 hover:bg-white hover:text-beige-academy-300"
                 @click="forward(message)" >
                  {{ $t('messages.forward') }}
              </button>
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <h5 v-else class="flex justify-center font-sans-serif">
      {{$t('messages.none-sent')}}
    </h5>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MessageForm from '@/components/modals/MessageForm.vue';

export default {
  data() {
    return {
      recipients: [],
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      messages: 'auth/sentMessages',
    }),
  },

  mounted() {
    if (this.messages) this.setRecipients();
  },

  methods: {
    setRecipients() {
      this.recipients = [];
      this.messages.forEach((message) => {
        if (!this.recipients.includes(message.to_user_id)) this.recipients.push(message.to_user_id);
      });
    },

    messagesToUser(id) {
      if (this.messages) { return this.messages.filter((message) => message.to_user_id === id); }
      return '';
    },

    answer(message) {
      this.$modal.show(
        MessageForm, { fromUser: this.user, toUser: message.to_user, subj: message.subject },
        { adaptive: true, draggable: true },
      );
    },

    forward(message) {
      this.$modal.show(
        MessageForm, { fromUser: this.user, toUser: '', subj: message.subject },
        { adaptive: true, draggable: true },
      );
    },
  },

};

</script>
